import React from "react";
import "../css/Site.css";
import {Button} from './Button';

import 'bootstrap/dist/css/bootstrap.min.css';
require('bootstrap/dist/js/bootstrap.bundle')


export class Banner extends React.Component {
    
   render() {
        return (
            <div className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
                <div className="dropdown">
                    <a href="/#" id="dropdownMenuLink" data-bs-toggle="dropdown" role="button" aria-expanded="false">
                        <img alt="" src={require('../update-changes/NavButton.fw.png')} id="navButton" />
                    </a>

                    <div className="dropdown-menu" style={{minWidth: '535px'}} id="navDropDown">          
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-12 NavPopoutHeader">
                                    NAM APPLICATIONS
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-sm-4">
                                    <a href="https://apps.nam.org/Search/Home/Index">
                                        <div className="navIconHolder">
                                            <img className="img-thumbnail navIcons" id="portalIcon" alt="" src={require('../update-changes/Portal-Icon.fw.png')} />
                                            <div style={{height:'40px', textAlign:'center', fontWeight:600, marginTop:'-40px', fontSize:'15px', color:'white'}}>NAMIS Search</div>
                                        </div>
                                    </a>
                                </div>
                                <div className="col-sm-4">
                                    <a href="https://apps.nam.org/IR">
                                        <div className="navIconHolder">
                                            <img className="img-thumbnail navIcons" id="irIcon" alt="" src={require('../update-changes/NAM_IndustryReports_building_white_icon.png')} />
                                            <div style={{height:'40px', textAlign:'center', fontWeight:600, marginTop:'-40px', fontSize:'15px', color:'white'}}>Industry Reports</div>
                                        </div>
                                    </a>
                                </div>
                                <div className="col-sm-4">
                                    <a href="https://apps.nam.org/GEO">
                                        <div className="navIconHolder">
                                            <img className="img-thumbnail navIcons" id="geoIcon" alt="" src={require('../update-changes/GEO-Icon.fw.png')} />
                                            <div style={{height:'40px', textAlign:'center', fontWeight:600, marginTop:'-40px', fontSize:'15px', color:'white'}}>NAM | GEO</div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            
                            <div className="row">
                                <div className="col-sm-4">
                                    <a href="http://namreports.nam.org/weblogviewer#/home">
                                        <div className="navIconHolder">
                                            <img className="img-thumbnail navIcons" id="WLVIcon" alt="" src={require('../update-changes/NAM_WeblogViewer_computerMonitor_white_icon.png')} />
                                            <div style={{height:'40px', textAlign:'center', fontWeight:600, marginTop:'-40px', fontSize:'15px', color:'white'}}>Web Log Viewer</div>
                                        </div>
                                    </a>
                                </div>
                                <div className="col-sm-4">
                                    <a href="https://apps.nam.org/meetings">
                                        <div className="navIconHolder">
                                            <img className="img-thumbnail navIcons" id="meetingIcon" alt="" src={require('../update-changes/meetings_trans.png')} />
                                            <div style={{height:'40px', textAlign:'center', fontWeight:600, marginTop:'-40px', fontSize:'15px', color:'white'}}>Meetings</div>
                                        </div>
                                    </a>
                                </div>
                                <div className="col-sm-4">
                                    <a href="https://apps.nam.org/list/matching">
                                        <div className="navIconHolder">
                                            <img className="img-thumbnail navIcons" id="lstIcon" alt="" src={require('../update-changes/NAM_Lists-white.png')} />
                                            <div style={{height:'40px', textAlign:'center', fontWeight:600, marginTop:'-40px', fontSize:'15px', color:'white'}}>List Matching</div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav me-auto d-lg-flex align-items-center">
                        <li className="nav-item">
                            <a className="nav-link align-middle" href="https://apps.nam.org">
                                <img id="NAMLogo" alt="ABC" src={require('../update-changes/NAM-Logo.fw.png')} />
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="https://apps.nam.org">
                                <div className="titleLineOne">
                                    National Association of<br />
                                </div>
                                <div className="titleLineTwo">
                                    Manufacturers
                                </div>
                            </a>
                        </li>                               
                        <li className="nav-item">
                            <a className="nav-link" href="/#">
                                <div className="spacerPipe">|</div>
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/#">
                            <div className="appTitle pull-left">NAMIS Reports</div>
                            </a>
                        </li>
                    </ul>
                    <div className="navbar-text ms-auto">
                        <a className="nav-link account-logout" href="/#" data-toggle="modal" data-target="#logoutModal"><Button /></a>
                    </div>      
                </div> 
            </div>
        );
    }
}